export const selectDocsFormData = (state) => state.docs.docsFormData;
export const selectRefiDocsFormData = (state) => state.docs.refiDocsFormData;
export const selectDocsCities = (state) => state.docs.cities;
export const selectDocsStates = (state) => state.docs.states;
export const selectDocsCountries = (state) => state.docs.countries;
export const selectDocsVinData = (state) => state.docs.vinData;
export const selectDocsResponse = (state) => state.docs.docsResponse;
export const selectTransactionId = (state) => state.docs.transactionId;
export const selectDocType = (state) => state.docs.type;
export const selectDocsLoadingState = (state) => state.docs.isLoading;
export const selectDocsError = (state) => state.docs.error;
export const selectMultiFormFeesError = (state) => state.docs.feesError;
export const selectDownloadLoadingState = (state) => state.docs.loading;
